import { useRef } from 'react';

import { useEffectOnce } from '@/hooks';

/**
 * 컴포넌트 마운트 시 자동으로 생성을 트리거합니다.
 *
 * Landing 페이지에서 프롬프트와 함께 진입한 경우,
 * 사용자 액션 없이 즉시 AI 생성을 시작합니다.
 *
 * @param enabled - Auto-trigger 활성화 여부
 * @param onTrigger - 트리거할 함수 (보통 generation.handleGenerate)
 *
 * @example
 * ```typescript
 * useAutoTrigger({
 *   enabled: features.autoTrigger,
 *   onTrigger: generation.handleGenerate,
 * });
 * ```
 */
export const useAutoTrigger = ({
  enabled,
  onTrigger,
}: {
  enabled: boolean;
  onTrigger?: () => void;
}) => {
  const hasTriggered = useRef(false);

  useEffectOnce(() => {
    if (enabled && !hasTriggered.current && onTrigger) {
      hasTriggered.current = true;
      onTrigger();
    }
  });
};
